// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-layout-div {
  display: flex;
  flex-direction: column;
  padding: 24px;
}
.page-layout-div .content-container {
  padding: 24px;
  background-color: #FFFFFF;
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.page-layout-div .content-container .header-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-left: 10px;
  align-items: center;
}
.page-layout-div .content-container .header-div .header-text {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 400;
  height: 30px;
}
.page-layout-div .content-container .header-div .button-div {
  display: flex;
  gap: 10px;
}
.page-layout-div .ant-divider-with-text-left::before {
  width: 80px;
}
.ant-message {
  margin-top: 125px;
}
.breadcrumb-div {
  margin-bottom: 25px;
}
.breadcrumb-div .home-breadcrumb {
  display: flex;
  align-items: center;
  width: 67px;
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/app/styles.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AADF;AAFA;EAMM,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AADN;AAVA;EAeU,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AAFV;AAlBA;EAsBY,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AADZ;AAzBA;EA8BU,aAAA;EACA,SAAA;AAFV;AA7BA;EAqCI,WAAA;AALJ;AASA;EACE,iBAAA;AAPF;AAUA;EACE,mBAAA;AARF;AAOA;EAII,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AARJ","sourcesContent":["// styling for layout of data displayed in every page:\n\n.page-layout-div {\n  display: flex;\n  flex-direction: column;\n  padding: 24px;\n\n  .content-container {\n      padding: 24px;\n      background-color: #FFFFFF;\n      min-height: 80vh;\n      display: flex;\n      flex-direction: column;\n      flex-grow: 1;\n\n\n      .header-div {\n          display: flex;\n          flex-direction: row;\n          justify-content: space-between;\n          margin-bottom: 20px;\n          margin-left: 10px;\n          align-items: center;\n          .header-text {\n            display: flex;\n            align-items: center;\n            font-size: 20px;\n            font-weight: 400;\n            height: 30px;\n        }\n\n        .button-div {\n          display: flex;\n          gap: 10px;\n        }\n      }\n  }\n\n  .ant-divider-with-text-left::before {\n    width: 80px;\n  }\n}\n\n.ant-message {\n  margin-top: 125px;\n}\n\n.breadcrumb-div {\n  margin-bottom: 25px;\n\n  .home-breadcrumb {\n    display: flex;\n    align-items: center;\n    width: 67px;\n    justify-content: space-between;\n  }\n}\n@error-color: #EB0004;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
